import config from '@/config';
import { logger } from '@/config/logger';
import { getStore } from '@/services/context';

import { SECRETS_TOTAL_COUNT_HEADER } from '../constants';
import { setSecretsTotalCount } from '../services/actions';

export async function totalCountInterceptor(response: Response) {
    try {
        const totalCount = response.headers.get(SECRETS_TOTAL_COUNT_HEADER);
        const store = await getStore();

        if (totalCount) {
            store.dispatch(setSecretsTotalCount(Number.parseInt(totalCount, 10)));
        } else if (response.url.endsWith(config.api.secrets)) {
            const clonedResponse = response.clone();

            const secrets = (await clonedResponse.json()) as unknown[];

            store.dispatch(setSecretsTotalCount(secrets.length));
        }
    } catch (e) {
        logger.error(e);
    }

    return response;
}
